import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  Clock, Mail, MessageCircle, Globe, Calendar, Lock,
  Users, Trophy, Zap, AlertTriangle
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo6 from "@assets/logos_extracted/6.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://spng.fynkelto.com/?mid=279656_1645837";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const depositMethods = [
  "PlayID", "Mastercard", "Paysafecard", "Skrill", "Nuvei",
  "Neteller", "Jetonbank", "MiFinity", "USDT TRC20", "USDT ERC20",
  "USDT BEP20", "Bitcoin", "Ethereum", "Litecoin", "Solana",
  "BNB", "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const withdrawalMethods = [
  "PlayID", "Visa", "Mastercard", "Bank Transfer", "Revolut",
  "Skrill", "Nuvei", "Neteller", "Jetonbank", "MiFinity",
  "USDT TRC20", "USDT ERC20", "USDT BEP20", "Bitcoin", "Ethereum",
  "Litecoin", "Solana", "BNB", "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const providers = "1X2 Gaming, 3 Oaks Gaming, 7777 Gaming, All41 Studios, Amatic Industries, Amusnet (EGT), Apollo Games, Arcade, Atmosfera, Belatra Games, Betsoft, Betsolutions, BF Games, BGaming, Bombay Live, Booming Games, Big Time Gaming, Caleta Gaming, Casino Technology, Claw, ELA Games, ELK Studios, Endorphina, Evolution Gaming, Evoplay Entertainment, Ezugi, Felix Gaming, Felt, Foxium, Fugaso, G.Games, Gamebeat, Gameburger Studios, Gaming Corps, Gaming Realms, Gamomat, Gamzix, Golden Rock Studios, Habanero, Hacksaw Gaming, High 5 Games, InBet Games, InOut, IronDog, JFTW, KA Gaming, Kalamba Games, Kiron Interactive, Leap Gaming, Lucky Streak, Mascot Gaming, Mercury, Microgaming, NetEnt, NetGaming, Nolimit City, Novomatic, Nucleus Gaming, Octoplay, OnAir, OneTouch, Onlyplay, Oryx, Platipus, Play\u2019n GO, PlayPearls, Playson, Playtech, Pocket Games Soft, Pragmatic Play, Pragmatic Play Live, Quickspin, Real Dealer Studios, Red Rake Gaming, Red Tiger Gaming, Relax Gaming, Revolver Gaming, Rogue Gaming, Ruby Play, Salsa Technology, Slotmill, Smartsoft Gaming, Spinmatic, Spinomenal, Spribe, StakeLogic, Stormcraft Studios, Swintt, Switch Studios, Thunderkick, Tom Horn Gaming, Triple Edge Studios, Turbo Games, Vibra Gaming, Wazdan, Woohoo, Yggdrasil, Zillion, LEMON";

const pros = [
  "Zábavné téma s motivem fotbalových sběratelských kartiček, které přidává soutěžní prvek ke klasickému hraní",
  "Casino i sázková část jsou snadno ovladatelné",
  "Silný důraz na sportovní sázky a gamifikaci",
  "Motivující VIP systém, pravidelné mise a cíle pro hráče",
];

const cons = [
  "Absence dedikované mobilní aplikace",
  "Některé grafické prvky mohou působit přeplácaně",
  "Podrobnosti o platebních limitech a metodách nejsou okamžitě dostupné",
  "Orientace v systému odměn může být složitější pro nováčky",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>Do 48 hodin (u kasina)</span></div>
        <div className={rowClass}><span className={labelClass}>Denní limit výběru:</span><span className={valueClass}>cca 12 500 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Týdenní limit:</span><span className={valueClass}>cca 75 000 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Měsíční limit:</span><span className={valueClass}>cca 175 000 Kč</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <span className={valueClass}>PlayID, Mastercard, Paysafecard, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, USDT TRC20/ERC20/BEP20, Bitcoin, Ethereum, Litecoin, Solana, BNB, Ripple, Bitcoin Cash, Dogecoin, Cardano</span>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <span className={valueClass}>PlayID, Visa, Mastercard, Bank Transfer, Revolut, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, USDT TRC20/ERC20/BEP20, Bitcoin, Ethereum, Litecoin, Solana, BNB, Ripple, Bitcoin Cash, Dogecoin, Cardano</span>
        </div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 4 000 titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Ano – klasické, video sloty, Megaways, bonus-buy, jackpoty</span></div>
        <div className={rowClass}><span className={labelClass}>Živé stoly:</span><span className={valueClass}>Ano – Evolution, Atmosfera a další</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>eSports:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Video poker:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Kryptoměny:</span><span className={valueClass}>Ano – hlavní krypto měny</span></div>
        <div className={rowClass}><span className={labelClass}>Poskytovatelé:</span><span className={valueClass}>40+ výrobců softwaru vč. Pragmatic Play, Play&apos;n GO, Evolution, Yggdrasil, BGaming</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>Dostupné 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@spinanga.com</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Web:</span><span className={valueClass}><a href="https://spinanga.com" target="_blank" rel="sponsored noopener noreferrer" className="text-[#003da5] hover:underline">spinanga.com</a></span></div>
        <div className={rowClass}><span className={labelClass}>Rok založení:</span><span className={valueClass}>2026</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan (zahraniční – mimo ČR)</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyk rozhraní:</span><span className={valueClass}>Čeština a další</span></div>
        <div className={rowClass}><span className={labelClass}>Měna účtu:</span><span className={valueClass}>CZK a další</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Responzivní web, bez samostatné aplikace</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Limit vkladu:", "Ano"],
      ["Limit sázek:", "Ano"],
      ["Limit ztrát:", "Ano"],
      ["Sebevyloučení:", "Ano"],
      ["Dočasná pauza:", "Ano"],
      ["Mobilní aplikace:", "Ne"],
      ["Česká licence MF:", "Ne"],
      ["Demo režim:", "Ano"],
    ];
    return (
      <div className="divide-y divide-[#eef1f7]">
        {items.map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={`${valueClass} ${value === "Ano" ? "text-green-600" : value === "Ne" ? "text-gray-400" : ""}`}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function SpinangaPage() {
  useSEO({ title: "Spinanga Casino Recenze 2026 – Bonus a hodnocení | HrajBonus", description: "Nezávislá recenze Spinanga Casino. Přehled uvítacího bonusu, výběru her, platebních metod a zákaznické podpory. Hodnocení 8.5/10. 18+",
  url: "https://hrajbonus.com/kasina/spinanga", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllDeposit, setShowAllDeposit] = useState(false);
  const [showAllWithdrawal, setShowAllWithdrawal] = useState(false);

  const depositVisible = showAllDeposit ? depositMethods : depositMethods.slice(0, 10);
  const withdrawalVisible = showAllWithdrawal ? withdrawalMethods : withdrawalMethods.slice(0, 10);

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo6} alt="Spinanga logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina Spinanga</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <Star className="w-5 h-5 fill-[#f5c518]/40 text-[#f5c518]" />
                  </div>
                  <span className="text-white font-bold text-xl">7.2</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",       value: "4 000+" },
                    { label: "Minimální vklad", value: "250 Kč" },
                    { label: "Minimální výběr", value: "250 Kč" },
                    { label: "Licence",         value: "Anjouan" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 Freespiny</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Spinanga" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">7.2</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Spinanga zaujme gamifikačním přístupem s motivem fotbalových sběratelských kartiček a bohatým portfoliem přes 4 000 her. Platforma nabídne pěknou kombinaci slotů, live kasina a sportovního sázení. Hodnocení snižuje absence české licence a hlasy hráčů o pomalejších výběrech – to jsou faktory, které je třeba vzít při rozhodování v potaz.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Intro */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">
                  Spinanga casino recenze: kompletní hodnocení
                </h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Spinanga patří mezi mezinárodní online kasina, která lákají české hráče bohatou nabídkou her, českou lokalizací a možností vkládat v korunách. Na první pohled to vypadá jako velmi lákavé místo pro hraní: katalog o tisících titulech, live Casino, sportovní sázky, kryptoměny a spousta promoakcí.
                </p>

                {/* Quick overview */}
                <div className="grid sm:grid-cols-2 gap-4 mb-6">
                  <div className="bg-green-50 border border-green-100 rounded-xl p-4">
                    <div className="font-bold text-green-800 text-sm mb-3">Silné stránky</div>
                    <ul className="space-y-1.5">
                      {[
                        "Velmi široká nabídka her: přes 4 000 titulů od více než 40 výrobců softwaru",
                        "Sportovní sázky v jednom účtu s kasinem",
                        "Přehledný web v češtině, CZK jako měna účtu",
                        "Pestré promoakce – uvítací balíčky, free spiny, cashbacky, krypto bonusy",
                        "Široká nabídka plateb včetně Skrill, Neteller a kryptoměn",
                      ].map(item => (
                        <li key={item} className="flex items-start gap-2 text-gray-700 text-xs">
                          <CheckCircle className="w-3.5 h-3.5 text-green-600 mt-0.5 flex-shrink-0" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="bg-red-50 border border-red-100 rounded-xl p-4">
                    <div className="font-bold text-red-800 text-sm mb-3">Slabé stránky</div>
                    <ul className="space-y-1.5">
                      {[
                        "Chybí česká licence – hraní českých hráčů není legální",
                        "Vysoké sázecí požadavky u většiny bonusů",
                        "Časté stížnosti na pomalé výběry a neosobní podporu",
                        "Limity výběrů a omezení pro bonusové hraní",
                        "Žádná samostatná mobilní aplikace",
                      ].map(item => (
                        <li key={item} className="flex items-start gap-2 text-gray-700 text-xs">
                          <XCircle className="w-3.5 h-3.5 text-red-500 mt-0.5 flex-shrink-0" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Key parameters table */}
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Parametr</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Hodnota</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Licence", "Zahraniční – mimo ČR"],
                        ["Jazyk rozhraní", "Čeština"],
                        ["Měna účtu", "CZK a další"],
                        ["Herní portfolio", "4 000+ her, 40+ poskytovatelů"],
                        ["Live Casino", "Ano – Evolution, Atmosfera a další"],
                        ["Sportovní sázky", "Ano"],
                        ["Kryptoměny", "Ano – hlavní krypto měny"],
                        ["Min. vklad", "od 250 Kč"],
                        ["Výběrové limity", "cca 12 500 Kč denně, 75 000 Kč týdně, 175 000 Kč měsíčně"],
                        ["Mobilní hraní", "Responzivní web, bez samostatné aplikace"],
                        ["Podpora", "24/7 chat a e-mail"],
                      ].map(([param, value], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-2.5 font-medium text-gray-700 text-xs">{param}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-gray-400 text-xs mt-2 italic">Poznámka redakce: parametry a limity se mohou měnit. Ověřte si je vždy v aktuálních podmínkách operátora.</p>
              </div>

              {/* Safety & licence */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost, licence a dopady pro českého hráče</h2>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-5">
                  <div className="flex items-start gap-2">
                    <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <div className="font-bold text-amber-800 text-sm mb-1">Licence mimo ČR</div>
                      <p className="text-amber-700 text-sm leading-relaxed">
                        Z pohledu českého práva nejde o legální hernu pro rezidenty. Spinanga funguje na základě zahraniční licence mimo EU. Pro české hráče to znamená zásadní nevýhodu: pokud dojde ke sporu, nelze využít nástroje českého regulátora a ochrana práv je slabší.
                      </p>
                    </div>
                  </div>
                </div>

                <p className="text-gray-600 leading-relaxed mb-4">
                  Provozovatel uvádí šifrování plateb a pravidelné audity her. To je dnes průmyslový standard, nicméně klíčová je dostupnost státního dozoru a možnost reálného řešení sporů. Absence české licence znamená, že:
                </p>
                <ul className="space-y-2 mb-5">
                  {[
                    "není dostupná ochrana přes MF ČR,",
                    "neplatí tuzemské povinné nástroje zodpovědného hraní,",
                    "výhry nemají benefity licencovaného režimu.",
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <AlertTriangle className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
                <p className="text-gray-600 leading-relaxed">
                  Smysl by tato platforma měla pro hráče z trhů, kde je provoz povolen a regulovaný místním dohledem, případně pro ty, kdo hledají kombinaci kasina, sportu a krypto plateb. Pro ČR volíme opatrnost a doporučujeme licencovaná tuzemská kasina.
                </p>
              </div>

              {/* Games */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Herní nabídka a kvalita lobby</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Tady Spinanga boduje. Najdete tu velké množství výherních automatů, stolních her i živých stolů. Katalog se snadno filtruje, pro nováčky i zkušené je rozhraní přehledné.
                </p>

                <ul className="space-y-2 mb-5">
                  {[
                    "Automaty: klasické 3-válce, moderní video sloty, Megaways, bonus-buy tituly, jackpoty",
                    "Stolní hry: ruleta, blackjack, baccarat, casino poker",
                    "Live Casino: široká paleta od rulety přes blackjack po herní show",
                    "Další hry: keno, bingo, různé instantní hry",
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>

                <p className="text-gray-600 text-sm mb-4">
                  Zástupné dodavatele mezi nejznámějšími: Pragmatic Play, Play&apos;n GO, Yggdrasil, BGaming, Betsoft, Merkur, Spinomenal. Live Casino staví hlavně na Evolution a dalších specialistech.
                </p>

                {/* Games table */}
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Kategorie</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Příklady titulů</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Vybraní poskytovatelé</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Automaty", "Sweet Bonanza, Gates of Olympus", "Pragmatic Play, Play\u2019n GO, BGaming"],
                        ["Megaways a bonus-buy", "Aztec Magic, Big Bass Megaways", "Pragmatic Play, Yggdrasil, iSoftBet"],
                        ["Stolní hry", "Evropská ruleta, Classic Blackjack", "Evolution, Belatra, ELA Games"],
                        ["Video poker", "Jacks or Better, Deuces Wild", "BGaming, Merkur"],
                        ["Live Casino", "Crazy Time, Monopoly Live, Mega Roulette", "Evolution, Atmosfera"],
                        ["Ostatní", "Keno, Bingo, Wheel hry", "Evoplay, Betsoft"],
                      ].map(([cat, titles, prov], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-2.5 font-medium text-gray-900 text-xs">{cat}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{titles}</td>
                          <td className="px-4 py-2.5 text-gray-500 text-xs">{prov}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-gray-500 text-xs mt-3 leading-relaxed">
                  Za zmínku stojí i neobvyklé varianty live her, které jinde na českém trhu běžně neuvidíte, včetně tématických rulet. Šířka nabídky je pro náročné hráče velké plus.
                </p>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy a promoakce: velká čísla, přísné podmínky</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Spinanga sází na výrazné bonusy. Zaujme uvítací balíček, týdenní roztočení, cashbacky i speciály pro kryptoměny. Je ale nutné počítat s vysokými sázecími požadavky a omezenými hrami pro plnění.
                </p>

                <ul className="space-y-2 mb-5">
                  {[
                    "Uvítací balíček: 100 % až 12 500 Kč, 200 free spinů a prvek Bonus Crab",
                    "Týdenní free spiny: 50 roztočení za kvalifikační vklad Po–Čt",
                    "Krypto bonusy: například 200 % až do 3 000 USDT pro první krypto vklad",
                    "Víkendový krypto reload: 75 % až 750 USDT + 100 FS",
                    "Cashback: live cashback kolem 25 % a VIP cashback týdně",
                    "Bonus bez vkladu: aktuálně nenabízen",
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <Trophy className="w-4 h-4 text-[#c9960f] mt-0.5 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>

                <div className="bg-amber-50 border border-amber-100 rounded-xl p-4 mb-5">
                  <div className="font-bold text-amber-800 text-sm mb-2">Podmínky, které stojí za pozornost:</div>
                  <ul className="space-y-1.5">
                    {[
                      "Uvítací bonus: typicky 35× vklad+bonus, výhry z free spinů 40×",
                      "Reloady a krypto promo: obvykle 30× až 40×",
                      "Cashback: jen 1× protočení, což je férové",
                      "Free spiny: často rozdělené do dávek po více dnů a omezené na vybrané hry",
                      "Časová omezení: povinnost splnit wager v krátkém časovém okně",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-2 text-gray-700 text-xs">
                        <AlertTriangle className="w-3.5 h-3.5 text-amber-600 mt-0.5 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Bonus table */}
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Bonus</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Parametry</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Sázecí podmínky</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Uvítací balíček", "100 % až 12 500 Kč + 200 FS + prvek Bonus Crab", "35× vklad+bonus, FS 40×"],
                        ["Týdenní free spiny", "50 FS za kvalifikační vklad Po–Čt", "Výhry z FS 40×"],
                        ["Krypto uvítací", "200 % až 3 000 USDT", "40× vklad+bonus"],
                        ["Víkendový krypto reload", "75 % až 750 USDT + 100 FS", "30× vklad+bonus, FS 30×"],
                        ["Live cashback", "25 % z čisté ztráty v live hrách", "1×"],
                        ["VIP cashback", "Týdně do 15 %", "1×"],
                      ].map(([bonus, params, wager], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-2.5 font-medium text-gray-900 text-xs">{bonus}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{params}</td>
                          <td className="px-4 py-2.5 text-gray-500 text-xs">{wager}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-gray-500 text-xs mt-3 italic">
                  Rada redakce: vždy si přečtěte kompletní bonusové podmínky. Sledujte maximální povolenou sázku na jedno roztočení při plnění, seznam zakázaných her a lhůty.
                </p>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Vklady, výběry a limity</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Platební metody jsou silnou stránkou Spinanga. Kromě karet Visa a Mastercard jsou podporovány e-peněženky a několik kryptoměn. Účet lze vést v CZK, což usnadňuje orientaci v bankrollu bez kurzových ztrát.
                </p>

                <div className="space-y-2 mb-5">
                  {[
                    "Minimální vklad: obvykle od 250 Kč",
                    "Kryptoměny: k dispozici hlavní sítě",
                    "Limity výběru: cca 12 500 Kč denně, 75 000 Kč týdně, 175 000 Kč měsíčně",
                    "Doba zpracování: oficiálně do 48 hodin u kasina, reálné doručení pak podle metody",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>

                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody vkladu</div>
                  <div className="flex flex-wrap gap-1.5">
                    {depositVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {depositMethods.length > 10 && (
                      <button onClick={() => setShowAllDeposit(!showAllDeposit)} className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline">
                        {showAllDeposit ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{depositMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="mb-6">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody výběru</div>
                  <div className="flex flex-wrap gap-1.5">
                    {withdrawalVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {withdrawalMethods.length > 10 && (
                      <button onClick={() => setShowAllWithdrawal(!showAllWithdrawal)} className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline">
                        {showAllWithdrawal ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{withdrawalMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Tipy, jak si u výplat ušetřit nervy:</div>
                  <ul className="space-y-1.5">
                    {[
                      "Ověřte účet hned po registraci – nahrát dokumenty včas se vyplatí",
                      "Držte se jedné platební metody pro vklad i výběr, pokud je to možné",
                      "Vyhněte se bonusům, pokud nechcete řešit sázecí požadavky",
                      "Výběry dělejte průběžně v menších částkách, ať nejste blokovaní limity",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                        <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <p className="text-gray-500 text-sm mt-4 leading-relaxed">
                  Hráčské recenze často upozorňují na dlouhé čekání. Proces ověřování identity a schvalování výběrů bývá zdrojem frustrace, zejména když se žádosti stornují nebo protahují. To je u zahraničních kasin bez domácí regulace typický problém.
                </p>
              </div>

              {/* Customer support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Spinanga nabízí 24/7 zákaznickou podporu přes live chat a e-mail. Hráčské zkušenosti občas hovoří o neosobním přístupu. Telefonická podpora není dostupná.
                </p>
                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@spinanga.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                    <HeadphonesIcon className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-700 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">není k dispozici</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Final verdict */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Výhody a nevýhody Spinanga v kostce</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-sm uppercase tracking-wide mb-3">
                      <CheckCircle className="w-4 h-4" /> Výhody
                    </div>
                    <ul className="space-y-2">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold text-base leading-none mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-sm uppercase tracking-wide mb-3">
                      <XCircle className="w-4 h-4" /> Nevýhody
                    </div>
                    <ul className="space-y-2">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold text-base leading-none mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Conclusion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <p className="text-gray-700 leading-relaxed">
                  Spinanga přináší gamifikaci a pestrou herní nabídku, která osloví hráče hledající kombinaci kasina, sportu a krypta. Hodnocení 7,2 z 10 odráží silné herní portfolio, ale i faktory jako absence české licence a hlasy o pomalejších výběrech.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo6} alt="Spinanga" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Spinanga</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <Star className="w-3 h-3 fill-[#f5c518]/40 text-[#f5c518]" />
                        <span className="text-gray-600 text-xs ml-1">7.2/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 Freespiny</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Globe,      label: "Web",          value: "spinanga.com" },
                      { icon: Calendar,   label: "Rok",          value: "2026" },
                      { icon: Lock,       label: "Licence",      value: "Anjouan" },
                      { icon: Users,      label: "Provozovatel", value: "Stellar Ltd" },
                      { icon: Gamepad2,   label: "Počet her",    value: "4 000+" },
                      { icon: Clock,      label: "Podpora",      value: "24/7 Live chat" },
                      { icon: CreditCard, label: "Min. vklad",   value: "250 Kč" },
                      { icon: Zap,        label: "Výplaty",      value: "Do 48 hod. (u kasina)" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="spinanga" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/allyspin" className="text-[#003da5] hover:underline" data-testid="review-link-allyspin">Allyspin</a>
              {" · "}
              <a href="/kasina/nomini" className="text-[#003da5] hover:underline" data-testid="review-link-nomini">Nomini</a>
              {" · "}
              <a href="/kasina/librabet" className="text-[#003da5] hover:underline" data-testid="review-link-librabet">Librabet</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
